import { PartnerType } from '@/app/utils/partners.enum'

export const JOURNEY_HEADER = 'x-journey-id'

export const JOURNEY_PRODUCT_HEADER = 'x-journey-product'

export const JOURNEY_FIELD = 'journeyId'

const journeys = new Map<PartnerType, string>()

export const journeyStore = {
  get(product?: PartnerType): string | undefined {
    return product ? journeys.get(product) : undefined
  },

  set(product: PartnerType, journeyId?: string) {
    if (journeyId) journeys.set(product, journeyId)
  },

  start(product: PartnerType) {
    journeys.delete(product)
  },

  clear(product: PartnerType) {
    journeys.delete(product)
  },

  clearAll() {
    journeys.clear()
  },
}
